import { reservationForm } from "@/utils/objects";
import { useEffect, useState } from "react";
import ReservationForm from "./form/ReservationForm";
import { mergeDateAndTime, submitCreateForm } from "@/utils/formChange";
import { useRefresh } from "react-admin";
import { Inventory } from "@/interface/entityInterface";

const ReservationCreate = () => {
  const refresh = useRefresh();
  const [formProp, setFormProp] = useState(reservationForm);
  const [selected, setSelected] = useState<Inventory[]>([]);
  const {name, phone, email, make, model, vin, license_plate, year, date, time, notes, reservation_items, technician_id } = formProp

  useEffect(() => {
    const reservationItems: any[] = [];
    selected.map((item) =>
      reservationItems.push({
        inventory_id: item.id,
        quantity: item.quantity || 1,
        price: item.price,
      }),
    );
    
    setFormProp((prev: any) => {
      return {
        ...prev,
        reservation_items: reservationItems,
      };
    });
  }, [selected]);

  return (
    <ReservationForm
      formProp={formProp}
      setFormProp={setFormProp}
      mode="create"
      otherData={selected}
      setOtherData={setSelected}
      submitForm={() =>
        submitCreateForm(
          "auto-service-reservation",
          { 
            client: {name, email, phone},
            vehicle: {make, model, year, vin, license_plate},
            date: mergeDateAndTime(date, time),
            technician_id: +formProp.technician_id,
            branch_id: +formProp.branch_id,
            notes, 
            status: "PENDING",
            reservation_items,
          },
          refresh,
        )
      }
    />
  );
};

export default ReservationCreate;
